// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.result-box[data-v-64a260d7] {\n    width: 400px;\n    margin: 10px 150px 0 10px;\n}\n.payment-form[data-v-64a260d7] {\n    padding: 10px;\n}\n.persist-button[data-v-64a260d7]:hover, .persist-button[data-v-64a260d7]:focus {\n    background-color: red;\n}\n\n", ""]);
// Exports
module.exports = exports;
